module.exports = __webpack_public_path__ + "img/b-pink-m.f5675c93.png";